export default "__VITE_ASSET__IydMojZP__"